import { render } from "./ClientOnly.vue?vue&type=template&id=05bb6b40"
import script from "./ClientOnly.vue?vue&type=script&lang=js"
export * from "./ClientOnly.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__